'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type CSSProperties, type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokListType } from '../../storyblok'
import { getNonEmptyStyleStringValue } from '../../styles/getNonEmptyStyleStringValue'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

import styles from './StoryblokList.module.css'

export const StoryblokList: FC<StoryblokComponentProps<StoryblokListType>> = ({
  blok,
}) => {
  return (
    <ul
      {...storyblokEditable(blok)}
      className={styles['storyblok-list']}
      style={
        {
          '--cms-list-grid-columns-desktop': getNonEmptyStyleStringValue(
            blok.desktopColumns,
          ),
        } as CSSProperties
      }
    >
      <StoryblokComponentsRenderer bloks={blok.items} />
    </ul>
  )
}
